(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('reportBuilder', reportBuilder);

    function reportBuilder($timeout, lodash, FILTER_OPERATOR_CONSTANT) {
        return {
            restrict: 'E',
            controller: reportBuilderCtrl,
            controllerAs: 'vm',
            bindToController: true,
            require: 'ngModel',
            scope: {
                options: '=',
                getModel: '=?'
            },
            templateUrl: 'common/app/components/report-builder',
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;
                vm.modelCtrl = ctrl;
                var firstLoad = true;
                $timeout(function () {
                    vm.getColumns();
                    vm.refreshQuery();

                    if (lodash.get(vm, 'options.watch_entity_type', false)) {
                        scope.$watch(vm.getEntityType, function (newVal, oldVal) {
                            if (firstLoad || (oldVal == newVal)) {
                                firstLoad = false;
                                return;
                            }

                            vm.options.columnsOptions.options = [];
                            vm.refreshColumnOptions();
                            var formData = lodash.get(vm.component_data, 'form', {});
                            vm.component_data.columns = [];
                            vm.component_data.filters = [];
                            vm.component_data.sort = [];
                            vm.resetQuery();

                            vm.saveDraft({
                                columns: [],
                                filters: [],
                                form: formData
                            });
                        });
                    }
                });

                ctrl.$formatters.push(function (modelValue) {
                    return modelValue;
                });

                ctrl.$render = function () {
                    scope.vm.component_data = ctrl.$viewValue;
                    $timeout(function () {
                        vm.setFilterQueries(scope.vm.component_data.filters);
                    });
                }
            }
        };
    }

    function reportBuilderCtrl(lodash, RequestHelper, FormBuilderService, $q) {
        var vm = this;
        this.$onInit = function() {
            vm._records = 0;
            vm.loading = false;
            vm.openPreview = openPreview;
            vm.hidePreview = hidePreview;
            vm.getComponentData = getComponentData;
            vm.generate = generate;
            vm.getModel = getComponentData;
            vm.getEntityType = getEntityType;
            vm.getColumns = getColumns;
            vm.getFilters = getFilters;
            vm.saveDraft = saveDraft;
            vm.setFormValidation = setFormValidation;
            vm.clearFormValidation = clearFormValidation;

            vm.component_data = {
                columns: [],
                filters: [],
                sort: [],
                form: {},
                schedule: {},
            };
        }


        function saveDraft(data) {
            vm.loading = true;
            var draftDs = lodash.get(vm, 'options.draft_datasource', null);
            if (!draftDs) {
                return;
            }

            RequestHelper.prepareDatasource(draftDs, data).then(function (res) {
                // get columns

                // get filters
                // vm.getColumns();
                // getFilters();
                console.log(res);
                vm.setFormModel(lodash.get(res, 'data.form', {}));

                //below code was added by Backend Coder
                vm.component_data.columns = lodash.get(res, 'data.columns', vm.component_data.columns);
                vm.component_data.filters = lodash.get(res, 'data.filters', vm.component_data.filters);
                vm.component_data.sort = lodash.get(res, 'data.sort', vm.component_data.sort);
                vm.component_data.rules = lodash.get(res, 'data.rules', vm.component_data.rules);
                vm.component_data.schedule = lodash.get(res, 'data.schedule', vm.component_data.schedule);
                vm.setFilterQueries(vm.component_data.filters);

                //end of Backend Coder Code

                $q.all([vm.getColumns(), vm.refreshQuery()]).then(function () {
                    vm.loading = false;
                })

            });
        }

        function getColumns() {
            var columnsDs = lodash.get(vm, 'options.columnsOptions.datasource', null);
            if (!columnsDs) {
                return;
            }
            var promise = RequestHelper.prepareDatasource(columnsDs, {})
            promise.then(function (res) {
                vm.options.columnsOptions.options = res.data;
                vm.refreshColumnOptions();
                // console.log(res);
            });

            return promise;
        }

        function getFilters() {
            var filterDs = lodash.get(vm, 'options.filterOptions.types.filter.datasource.init', null);

            if (!filterDs) {
                return;
            }

            var promise = RequestHelper.prepareDatasource(filterDs, {});

            promise.then(function (res) {
                // vm.options.columnsOptions.options = res.data;
                // console.log(res);
            });

            return promise;
        }

        function getEntityType() {
            if (!vm.getFormModel) {
                return false;
            }
            const formData = vm.getFormModel();
            return lodash.get(formData, vm.options.watch_entity_type, false);
        }

        function openPreview() {
            console.log('report builder open preview is clicked');
            if (!vm.preview_is_active) {
                vm.generate();
                vm.preview_is_active = true;
            }
        };

        function hidePreview() {
            vm.preview_is_active = false;
        };

        function getComponentData() {
            var data = angular.copy(vm.component_data);
            data.filters = (vm.getQuery) ? vm.getQuery() : [];
            data.form = vm.getFormModel();
            return data;
        }

        function generate() {
            var config = vm.getComponentData();
            vm.options.previewOptions = {
                columns: [{
                    title: "#",
                    field: '_index',
                    headerAttributes: {
                        'class': 'first-column text-right'
                    },
                    width: 65,
                    attributes: {
                        'class': 'first-column text-right',
                    }
                }].concat(lodash.sortBy(config.columns, lodash.get(vm.options, 'columnsOptions.sortField', 'position')).map(function (column) {
                    column.width = '120px';
                    return column;
                })),
                dataSource: lodash.fill(Array(100), null).map(function (value, index) {
                    return config.columns.reduce(function (result, column) {
                        result[column.field] = column.title + ' ' + (index + 1);
                        return result;
                    }, {_index: (index + 1)});
                }),
                dataBinding: function () {
                    vm._records = (this.dataSource.page() - 1) * this.dataSource.pageSize();
                },
                scrollable: true
            };
            console.log(config);
            // vm.previewGrid.setOptions(vm.options.previewOptions);
            // vm.preview_is_active = true;
        }


        function setFormValidation(form_validation_rules) {
            const formId = lodash.get(vm, 'options.form.name', false);
            if (!formId) return false;

            const fbService = FormBuilderService.get(formId);
            if (lodash.has(fbService, 'elementsService.setValidationRules')) {
                fbService.elementsService.setValidationRules(form_validation_rules, null, true);
            }
        }

        function clearFormValidation() {
            const formId = lodash.get(vm, 'options.form.name', false);
            if (!formId) return false;

            const fbService = FormBuilderService.get(formId);
            if (lodash.has(fbService, 'elementsService.setValidationRules')) {
                fbService.elementsService.setValidationRules(null, null, true);
            }
        }
    }
})();